<template>
  <div class="signup-flow modal-dynamic-width" :class="'modal-size' + currentStep">
    <step-indicator
      :steps="indicatorSteps"
      :current="currentStep"
      :disabled="loading || stepsFinished"
      width="400px"
      @click-step="stepChanged"
    />
    <div class="close-btn" @click="$emit('close')" v-if="!stepsFinished">
      <i class="fa-light fa-times"></i>
    </div>
    <transition name="first">
      <div class="first" v-if="currentStep == 1">
        <SignUpForm
          class="signup-form"
          :knownInfo="signupInfo"
          :invalidEmail="userExistsError"
          :invalidEmailMsg="userExistsErrorMsg"
          :title="$t('demo.signup-flow.step-1.title')"
          :btnText="$t('demo.signup-flow.step-1.btn-text')"
          @on-submit="accountInfo"
          @valid="firstStepValid"
        />
      </div>
    </transition>

    <!-- <transition :name="midTransition">
      <div v-if="currentStep == 2">
        <h3 class="pricing-title">Pick a plan</h3>
        <p class="description">
          Please pick a plan that fits your need to start the
          <strong>1 month free trial.</strong> You do not need any credit card to start the trial.
        </p>
        <PickPlan @plan-picked="planPicked" />
        <p class="skip-plan text-small" @click="planPicked('')">I will decide later</p>
      </div>
    </transition> -->
    <transition name="last">
      <div v-if="currentStep == 2">
        <div v-if="loading">
          <p class="description text-muted">
            <span>
              {{$t('demo.signup-flow.step-2.loading-message')}}
            </span>
            <span>
              <i class="fa-light fa-circle-notch fa-spin"></i>
            </span>
          </p>
        </div>
        <div v-else>
          <div v-if="signupError">
            <p class="description text-danger">
              {{$t('demo.signup-flow.step-2.signup-error')}}
            </p>
            <button class="btn btn-primary btn-revert" @click="signupDemoUser()">{{$t('retry')}}</button>
          </div>
          <div v-else>
            <h3 class="done-title">{{$t('demo.signup-flow.step-2.success.title')}}</h3>
            <p class="description" v-html="$t('demo.signup-flow.step-2.success.description-1')"></p>
            <p class="description" v-html="$t('demo.signup-flow.step-2.success.description-2')"></p>
            <p class="text-xs text-muted button-desc">{{$t('demo.signup-flow.step-2.success.small-text')}}</p>
            <div class="actions">
              <button :disabled="signupError" class="btn btn-primary btn-sm" @click="handleRedirectToApp()">
                {{$t('demo.signup-flow.step-2.success.to-app')}}
              </button>
              <button :disabled="signupError" class="btn btn-secondary btn-sm" @click="$emit('close')">
                {{$t('demo.signup-flow.step-2.success.continue-demo')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { stepIndicatorMixin } from "@/assets/js/stepIndicatorMixin.js";
import StepIndicator from "@/components/StepIndicator.vue";
import SignUpForm from "@/components/SignUpForm";
import PickPlan from "@/components/PickPlan.vue";
import appHelper from "@/assets/js/appHelper.js";
export default {
  mixins: [stepIndicatorMixin],
  components: { SignUpForm, StepIndicator, PickPlan },
  name: "DemoSignUp",
  data() {
    return {
      signupInfo: {
        name: "",
        user: {
          username: "",
          password: "",
          name: "",
          phone: ""
        },
        plan: "",
        demoKey: ""
      },
      stepsFinished: false,
      midTransition: "mid-next",
      loading: false,
      readyToStart: false,
      currentStep: 1,
      indicatorSteps: [
        {
          step: 1,
          title: this.$t('demo.signup-flow.step-indicator.user-details'),
          allowed: true,
          visited: true,
          valid: false,
          disabled: false
        },
        // {
        //   step: 2,
        //   title: "Plan info",
        //   allowed: false,
        //   deniedAccessMsg: "Please fill out the form first",
        //   visited: false,
        //   valid: false,
        //   disabled: false
        // },
        {
          step: 2,
          title: this.$t('demo.signup-flow.step-indicator.start-trial'),
          allowed: false,
          deniedAccessMsg: this.$t('demo.signup-flow.step-indicator.denied-access'),
          visited: false,
          valid: false,
          disabled: false
        }
      ],
      signupError: false,
      userExistsError: false,
      userExistsErrorMsg: ""
    };
  },
  methods: {
    // planPicked(plan) {
    //   this.$set(this.signupInfo, "plan", plan);
    //   this.indicatorSteps[1].visited = true;
    //   this.indicatorSteps[1].valid = true;
    //   this.signupDemoUser();
    // },

    signupDemoUser() {
      this.signupError = false;
      this.userExistsError = false;
      // this.stepChanged(3);
      this.loading = true;
      this.$store
        .dispatch("signupFromDemo", this.signupInfo)
        .then((res) => {
          this.stepsFinished = true;
          // this.indicatorSteps[2].valid = true;
          this.indicatorSteps[1].valid = true;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          this.signupError = true;
          if (e.status == 400) {
            const baseUrl = appHelper.getBaseUrl();
            this.userExistsError = true;
            this.userExistsErrorMsg = `${this.$t('demo.signup-flow.step-1.user-exists-error')} - <a href="${baseUrl}/login">${this.$t('demo.signup-flow.step-1.to-login')}</a>`;
            this.indicatorSteps[0].valid = false;
            this.stepChanged(1);
          }
        });
    },

    accountInfo(data) {
      
      this.stepChanged(2);
      this.signupDemoUser();
    },

    stepChanged(to) {
      this.midTransition = this.nextTransition(this.currentStep, to);
      this.$nextTick(() => {
        this.currentStep = to;
      });
    },

    firstStepValid(status) {
      this.indicatorSteps[0].valid = status;
      this.indicatorSteps[1].allowed = status;
    },

    handleRedirectToApp() {
      const baseUrl = appHelper.getBaseUrl();
      window.location.href = `${baseUrl}/login?signupFromDemo=${this.signupInfo.user.username}`;
    }
  },
  mounted() {
    this.$set(this.signupInfo.user, "username", this.demoUser.email);
    this.$set(this.signupInfo.user, "name", this.demoUser.userName);
    this.$set(this.signupInfo, "demoKey", this.$store.state.demoData.metadata.demoKey);

    if (this.$store.state.userDevice != "desktop") { // Hack to set dynamic width on modals on tablets
      document.querySelector("#modals-container").classList.add("modal-responsive");
    }
  },
  computed: {
    demoUser() {
      return this.$store.state.demoData.metadata.user;
    },
    secondStepValid() {
      const urlRegex = /^(?:(ftp|http|https)?:\/\/)?(?:[\w-]+\.)+([a-z]|[A-Z]|[0-9]){2,6}$/gi;
      return false;
    }
  },
  watch: {
    secondStepValid: {
      handler: function() {
        this.indicatorSteps[1].valid = this.secondStepValid;
        // this.indicatorSteps[2].allowed = this.secondStepValid;
      },
      immediate: true
    }
  }
};
</script>

<style lang="less">
#modals-container.modal-responsive {
  .v--modal-box.v--modal {
    left: 50vw !important;
    transform: translateX(-50%) !important;
  }
}
.v--modal-box.v--modal:has(.signup-flow.modal-dynamic-width) {
  left: 50% !important;
  transform: translateX(-50%) !important;
  // transition: height .1s !important;
}
.v--modal-box.v--modal:has(.signup-flow.modal-dynamic-width.modal-size1) {
  width: 750px !important;
}
.v--modal-box.v--modal:has(.signup-flow.modal-dynamic-width.modal-size2) {
  // width: 910px !important;
  width: 500px !important;
}
.v--modal-box.v--modal:has(.signup-flow.modal-dynamic-width.modal-size3) {
  width: 500px !important;
}
.signup-flow {
  padding: 16px 32px;
  position: relative;

  .close-btn {
    cursor: pointer;
    position: absolute;
    right: 8px;
    top: 8px;
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    color: var(--charcoal-50);
    &:hover {
      color: var(--charcoal);
    }
  }
  .signup-form {
    margin-top: 8px;
  }
  .button-desc {
    margin-bottom: 8px;
    font-style: italic;
  }
  .actions {
    display: flex;
    gap: 12px;
  }
}
#app h3.pricing-title,
#app h3.done-title {
  font-size: 24px;
  margin-bottom: 16px;
}
.skip-plan {
  display: inline-block;
  cursor: pointer;
  margin-top: 16px;
  text-decoration: underline;
  color: #6c757d;

  &:hover {
    color: var(--charcoal);
  }
}

@media only screen and (max-width: 1180px) {
  #modals-container.modal-responsive .v--modal-box.v--modal {
    width: 500px !important;
  }
  #modals-container.modal-responsive .v--modal-box.v--modal {
    width: 500px !important;
  }
  .v--modal-box.v--modal:has(.signup-flow.modal-dynamic-width.modal-size1){
    width: 500px !important;
  }
  .v--modal-box.v--modal:has(.signup-flow.modal-dynamic-width.modal-size2){
    width: 500px !important;
  }
  .signup-flow {
    .sign-up-box {
      h1 {
        max-width: 400px;
        margin: 0 auto;
      }
      form {
        display: block;
        max-width: 400px;
        margin: 0 auto;
        .final-group {
          display: flex;
          flex-direction: column-reverse;
          gap: 8px;
          .contact {
            align-self: flex-start;
          }
        }
      }
    }
    .requirements {
      position: relative;
    }
  }

  .pick-plan {
    flex-wrap: wrap;
    .plan-card {
      flex-basis: 200px;
      .content-wrapper {
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-between;
        button {
          align-self: center;
          width: max-content;
        }
      }
    }
  }
}
</style>
